import { gsap, ScrollTrigger } from "@/composeables/gsap";

// Marquee immer dann, wenn die Reihe nicht in eine Zeile passt — unabhängig von
// der Viewport-Breite. Passt sie rein, bleibt sie statisch mit dem
// gestaffelten Reveal.
const SPEED_PX_PER_SEC = 50;

export const init = () => {

    gsap.utils.toArray(".section-public-media").forEach(function (section) {

        const row = section.querySelector(".public-media-logo-row");
        if (!row) return;

        const getItems = () =>
            [...row.querySelectorAll(":scope > li:not([data-clone])")];
        if (!getItems().length) return;

        // Viewport-Wrapper (clipt im Marquee-Modus) einmalig um die <ul> legen.
        let viewport = row.parentElement;
        if (!viewport || !viewport.classList.contains("public-media-logo-row__viewport")) {
            viewport = document.createElement("div");
            viewport.className = "public-media-logo-row__viewport";
            row.parentNode.insertBefore(viewport, row);
            viewport.appendChild(row);
        }

        let loopTween = null;
        let revealBatch = null;
        let io = null;

        const getGap = () => {
            const g = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap);
            return Number.isFinite(g) ? g : 0;
        };

        const reset = () => {
            if (loopTween) { loopTween.kill(); loopTween = null; }
            if (revealBatch) { revealBatch.forEach((st) => st.kill && st.kill()); revealBatch = null; }
            if (io) { io.disconnect(); io = null; }
            row.querySelectorAll("[data-clone]").forEach((c) => c.remove());
            section.classList.remove("section-public-media--marquee");
            gsap.set(row, { clearProps: "transform" });
            gsap.set(getItems(), { clearProps: "opacity,visibility,transform" });
        };

        const build = () => {
            reset();

            const items = getItems();
            const gap = getGap();

            // Echte einzeilige Inhaltsbreite (Summe Item-Breiten + Gaps), unabhängig
            // von flex-wrap / Grid-Stauchung.
            const contentWidth =
                items.reduce((sum, li) => sum + li.getBoundingClientRect().width, 0) +
                gap * Math.max(0, items.length - 1);

            const overflows = contentWidth > viewport.clientWidth + 1;

            // Passt in eine Zeile: statisch + gestaffelter Reveal (links → rechts).
            if (!overflows) {
                gsap.set(items, { autoAlpha: 0, x: -24 });
                revealBatch = ScrollTrigger.batch(items, {
                    interval: 0.1,
                    invalidateOnRefresh: true,
                    start: "top bottom",
                    end: "bottom top",
                    onEnter: (batch) => gsap.to(batch, { autoAlpha: 1, x: 0, stagger: 0.12, overwrite: true, ease: "expo", duration: 0.9 }),
                });
                return;
            }

            // Passt nicht in eine Zeile: Marquee. Items klonen -> nahtloser Endlos-Loop.
            section.classList.add("section-public-media--marquee");
            gsap.set(items, { autoAlpha: 1 });
            items.forEach((li) => {
                const clone = li.cloneNode(true);
                clone.setAttribute("data-clone", "");
                clone.setAttribute("aria-hidden", "true");
                gsap.set(clone, { autoAlpha: 1 });
                row.appendChild(clone);
            });

            const oneSetWidth = contentWidth + gap;
            if (oneSetWidth <= 0) return;

            loopTween = gsap.to(row, {
                x: -oneSetWidth,
                duration: oneSetWidth / SPEED_PX_PER_SEC,
                ease: "none",
                repeat: -1,
            });

            io = new IntersectionObserver(([entry]) => {
                if (!loopTween) return;
                entry.isIntersecting ? loopTween.play() : loopTween.pause();
            }, { rootMargin: "150px" });
            io.observe(section);
        };

        build();

        let resizeTimer = null;
        const scheduleBuild = () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(build, 200); };
        window.addEventListener("resize", scheduleBuild);
        window.addEventListener("load", scheduleBuild);

    });
}

export default init;
